import mapboxundercover from './mapbox_undercover'


var style = {
    "version": 8,
    "name": "voltadolago-copy",
    "metadata": {
        "mapbox:autocomposite": true,
        "mapbox:type": "template",
        "mapbox:sdk-support": {
            "js": "latest",
            "android": "latest",
            "ios": "latest"
        },
        "mapbox:groups": {
            "Land & water, land": {
                "collapsed": false,
                "name": "Land & water, land"
            },
            "Land & water, water": {
                "collapsed": false,
                "name": "Land & water, water"
            },
            "Land & water, built": {
                "name": "Land & water, built",
                "collapsed": true
            },
            "Satellite imagery, land": {
                "collapsed": false,
                "name": "Satellite imagery, land"
            }
        }
    },
    "center": [
        -47.897861935212546,
        -15.781926868709519
    ],
    "zoom": 13.451546330428382,
    "bearing": -13.600000000001955,
    "pitch": 68.49999999999994,
    "light": {
        "color": "hsla(197, 60%, 78%, 0.67)",
        "intensity": 0.87,
        "anchor": "viewport"
    },
    "lights": [
        {
            "id": "ambient",
            "type": "ambient",
            "properties": {
                "intensity": 0.17
            }
        },
        {
            "id": "directional",
            "type": "directional",
            "properties": {
                "cast-shadows": true,
                "color": "hsl(208, 73%, 85%)",
                "intensity": 0.65
            }
        }
    ],
    // "terrain": {
    //     "source": "mapbox-dem",
    //     "exaggeration": 0
    // },
    "terrain": null,
    "fog": {
        "color": "hsl(220, 88%, 67%)",
        "space-color": [
            "interpolate",
            [
                "linear"
            ],
            [
                "zoom"
            ],
            4,
            "#010b19",
            7,
            "#367ab9"
        ],
        "high-color": "hsl(265, 87%, 52%)"
    },
    "sources": {
        "mapbox://mapbox.satellite": {
            "url": "mapbox://mapbox.satellite",
            "type": "raster",
            "tileSize": 256,
            "data": {
                "attribution": "<a href=\"https://www.mapbox.com/about/maps/\" target=\"_blank\" title=\"Mapbox\" aria-label=\"Mapbox\">&copy; Mapbox</a> <a href=\"https://www.openstreetmap.org/about/\" target=\"_blank\" title=\"OpenStreetMap\" aria-label=\"OpenStreetMap\">&copy; OpenStreetMap</a> <a class=\"mapbox-improve-map\" href=\"https://www.mapbox.com/contribute/\" target=\"_blank\" title=\"Improve this map\" aria-label=\"Improve this map\">Improve this map</a> <a href=\"https://www.maxar.com/\" target=\"_blank\" title=\"Maxar\" aria-label=\"Maxar\">&copy; Maxar</a>",
                "autoscale": true,
                "bounds": [
                    -180,
                    -85,
                    180,
                    85
                ],
                "cacheControl": "max-age=43200,s-maxage=2592000",
                "center": [
                    0,
                    0,
                    3
                ],
                "created": 1358310600000,
                "id": "mapbox.satellite",
                "mapbox_logo": true,
                "maxzoom": 22,
                "minzoom": 0,
                "modified": 1614877124000,
                "name": "Mapbox Satellite",
                "private": false,
                "scheme": "xyz",
                "tilejson": "3.0.0",
                "tiles": [
                    "https://a.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoidGhlc2NvdHQiLCJhIjoiNHRQei1XRSJ9.oXyqRV4MMG4bTG1dMb6Rig",
                    "https://b.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoidGhlc2NvdHQiLCJhIjoiNHRQei1XRSJ9.oXyqRV4MMG4bTG1dMb6Rig"
                ],
                "webpage": "https://studio.mapbox.com/tilesets/mapbox.satellite"
            }
        },
        "mapbox-dem": {
            "url": "mapbox://mapbox.mapbox-terrain-dem-v1",
            "type": "raster-dem",
            "tileSize": 512,
            "data": {
                "attribution": "<a href=\"https://www.mapbox.com/about/maps/\" target=\"_blank\" title=\"Mapbox\" aria-label=\"Mapbox\">&copy; Mapbox</a>",
                "autoscale": true,
                "bounds": [
                    -180,
                    -85,
                    180,
                    85
                ],
                "cacheControl": "max-age=43200,s-maxage=604800",
                "center": [
                    0,
                    0,
                    3
                ],
                "created": 1604614692000,
                "description": "png or webp file extension must be used. height = -10000 + ((R * 256 * 256 + G * 256 + B) * 0.1)",
                "encoding": "mapbox",
                "filesize": 0,
                "format": "png",
                "id": "mapbox.mapbox-terrain-dem-v1",
                "mapbox_logo": true,
                "maxzoom": 14,
                "minzoom": 0,
                "modified": 1605833570000,
                "name": "Mapbox Terrain-DEM v1",
                "packs": {
                    "scheme": [
                        {
                            "indexzoom": 0,
                            "maxzoom": 5,
                            "minzoom": 0
                        },
                        {
                            "indexzoom": 6,
                            "maxzoom": 9,
                            "minzoom": 6
                        },
                        {
                            "indexzoom": 10,
                            "maxzoom": 12,
                            "minzoom": 10
                        },
                        {
                            "indexzoom": 11,
                            "maxzoom": 14,
                            "minzoom": 13
                        }
                    ]
                },
                "private": false,
                "scheme": "xyz",
                "tilejson": "3.0.0",
                "tiles": [
                    "https://a.tiles.mapbox.com/raster/v1/mapbox.mapbox-terrain-dem-v1/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFsaS1idSIsImEiOiJjandjOGdlMXAwMGh6NDltdGk0bmY4YXkwIn0.Z5AcVPRIql1pU1-pH1GKIg",
                    "https://b.tiles.mapbox.com/raster/v1/mapbox.mapbox-terrain-dem-v1/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFsaS1idSIsImEiOiJjandjOGdlMXAwMGh6NDltdGk0bmY4YXkwIn0.Z5AcVPRIql1pU1-pH1GKIg"
                ],
                "webpage": "https://studio.mapbox.com/tilesets/mapbox.mapbox-terrain-dem-v1"
            }
        },
        "composite": {
            "url": "mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2",
            "type": "vector",
            "data": {
                "attribution": "<a href=\"https://www.mapbox.com/about/maps/\" target=\"_blank\" title=\"Mapbox\" aria-label=\"Mapbox\">&copy; Mapbox</a> <a href=\"https://www.openstreetmap.org/about/\" target=\"_blank\" title=\"OpenStreetMap\" aria-label=\"OpenStreetMap\">&copy; OpenStreetMap</a> <a class=\"mapbox-improve-map\" href=\"https://www.mapbox.com/contribute/\" target=\"_blank\" title=\"Improve this map\" aria-label=\"Improve this map\">Improve this map</a>",
                "bounds": [
                    -180,
                    -85,
                    180,
                    85
                ],
                "center": [
                    0,
                    0,
                    0
                ],
                "constituents": [
                    {
                        "maxzoom": 16,
                        "minzoom": 0,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "maxzoom": 15,
                        "minzoom": 0,
                        "source": "mapbox.mapbox-terrain-v2"
                    }
                ],
                "format": "pbf",
                "language_options": {
                    "all": "Every available language",
                    "ar": "Arabic",
                    "ca": "Catalan",
                    "cs": "Czech",
                    "da": "Danish",
                    "de": "German",
                    "el": "Greek",
                    "en": "English",
                    "es": "Spanish",
                    "fa": "Farsi",
                    "fi": "Finnish",
                    "fr": "French",
                    "he": "Hebrew",
                    "hu": "Hungarian",
                    "id": "Indonesian",
                    "it": "Italian",
                    "ja": "Japanese",
                    "ka": "Georgian",
                    "ko": "Korean",
                    "local": "Renderable local language",
                    "lv": "Latvian",
                    "ms": "Malay",
                    "nb": "Norwegian Bokmål",
                    "nl": "Dutch",
                    "no": "Norwegian",
                    "pl": "Polish",
                    "pt": "Portuguese",
                    "ro": "Romanian",
                    "ru": "Russian",
                    "sk": "Slovak",
                    "sl": "Slovenian",
                    "sr": "Serbian",
                    "sv": "Swedish",
                    "th": "Thai",
                    "tl": "Tagalog",
                    "tr": "Turkish",
                    "uk": "Ukrainian",
                    "vi": "Vietnamese",
                    "zh-Hans": "Simplified Chinese",
                    "zh-Hant": "Traditional Chinese"
                },
                "mapbox_logo": true,
                "maskLevel": 9,
                "maxzoom": 16,
                "minzoom": 0,
                "name": "Mapbox Terrain v2 + Mapbox Streets v8",
                "scheme": "xyz",
                "tilejson": "3.0.0",
                "tiles": [
                    "https://a.tiles.mapbox.com/v4/mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2/{z}/{x}/{y}.vector.pbf?access_token=pk.eyJ1IjoibWlsaXRhcnlzdW1tYXJ5IiwiYSI6ImNsN2V1Z3Y3NjAzeXgzeW8xajdrd253MmsifQ.-oTSYjAAbsq9OEf6u-9OiA",
                    "https://b.tiles.mapbox.com/v4/mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2/{z}/{x}/{y}.vector.pbf?access_token=pk.eyJ1IjoibWlsaXRhcnlzdW1tYXJ5IiwiYSI6ImNsN2V1Z3Y3NjAzeXgzeW8xajdrd253MmsifQ.-oTSYjAAbsq9OEf6u-9OiA"
                ],
                "vector_layers": [
                    {
                        "id": "landuse",
                        "minzoom": 5,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "waterway",
                        "minzoom": 7,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "water",
                        "minzoom": 0,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "aeroway",
                        "minzoom": 9,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "structure",
                        "minzoom": 13,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "building",
                        "minzoom": 12,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "landuse_overlay",
                        "minzoom": 5,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "road",
                        "minzoom": 3,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "admin",
                        "minzoom": 0,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "place_label",
                        "minzoom": 0,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "airport_label",
                        "minzoom": 8,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "transit_stop_label",
                        "minzoom": 5,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "natural_label",
                        "minzoom": 0,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "poi_label",
                        "minzoom": 6,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "motorway_junction",
                        "minzoom": 9,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "housenum_label",
                        "minzoom": 16,
                        "source": "mapbox.mapbox-streets-v8"
                    },
                    {
                        "id": "landcover",
                        "maxzoom": 22,
                        "minzoom": 0,
                        "source": "mapbox.mapbox-terrain-v2"
                    },
                    {
                        "id": "hillshade",
                        "maxzoom": 22,
                        "minzoom": 0,
                        "source": "mapbox.mapbox-terrain-v2"
                    },
                    {
                        "id": "contour",
                        "maxzoom": 22,
                        "minzoom": 0,
                        "source": "mapbox.mapbox-terrain-v2"
                    }
                ],
                "worldview_default": "US",
                "worldview_options": {
                    "ALL": "Every available worldview",
                    "AR": "Argentina",
                    "CN": "China",
                    "IN": "India",
                    "JP": "Japan",
                    "MA": "Morocco",
                    "RS": "Serbia",
                    "RU": "Russia",
                    "TR": "Turkey",
                    "US": "United States"
                }
            }
        }
    },
    "sprite": "mapbox://sprites/leceles/cm3gg5sjq001f01r2cl0cgfdy/5ganr5dqasvvxz4gv70tcwi79",
    "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
    "layers": [
        {
            "id": "land",
            "type": "background",
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "background-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    "#000",
                    11,
                    "rgb(36, 36, 36)"
                ]
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, land"
            }
        },
        {
            "layout": {
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, land"
            },
            "maxzoom": 12,
            "filter": [
                "match",
                [
                    "get",
                    "class"
                ],
                [
                    "scrub",
                    "grass"
                ],
                [
                    "step",
                    [
                        "zoom"
                    ],
                    true,
                    8,
                    false
                ],
                true
            ],
            "type": "fill",
            "source": "composite",
            "id": "landcover",
            "paint": {
                "fill-color": "hsl(0, 80%, 34%)",
                "fill-opacity": [
                    "interpolate",
                    [
                        "exponential",
                        1.5
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    0.4,
                    10,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "crop",
                        0,
                        0.4
                    ],
                    11,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "crop",
                        0,
                        0.4
                    ],
                    12,
                    0
                ],
                "fill-antialias": false
            },
            "source-layer": "landcover"
        },
        {
            "minzoom": 5,
            "layout": {
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, land"
            },
            "filter": [
                "==",
                [
                    "get",
                    "class"
                ],
                "national_park"
            ],
            "type": "fill",
            "source": "composite",
            "id": "national-park",
            "paint": {
                "fill-color": "rgb(31, 31, 31)",
                "fill-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    5,
                    0,
                    6,
                    0.6,
                    12,
                    0.2
                ]
            },
            "source-layer": "landuse_overlay"
        },
        {
            "minzoom": 5,
            "layout": {
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, land"
            },
            "filter": [
                "all",
                [
                    ">=",
                    [
                        "to-number",
                        [
                            "get",
                            "sizerank"
                        ]
                    ],
                    0
                ],
                [
                    "match",
                    [
                        "get",
                        "class"
                    ],
                    [
                        "agriculture",
                        "wood",
                        "grass",
                        "scrub",
                        "glacier",
                        "pitch",
                        "sand"
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        11,
                        true
                    ],
                    "residential",
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        true,
                        10,
                        false
                    ],
                    [
                        "park",
                        "airport"
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        8,
                        [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "sizerank"
                                ],
                                1
                            ],
                            true,
                            false
                        ],
                        10,
                        true
                    ],
                    false
                ],
                [
                    "<=",
                    [
                        "-",
                        [
                            "to-number",
                            [
                                "get",
                                "sizerank"
                            ]
                        ],
                        [
                            "interpolate",
                            [
                                "exponential",
                                1.5
                            ],
                            [
                                "zoom"
                            ],
                            12,
                            0,
                            18,
                            14
                        ]
                    ],
                    14
                ]
            ],
            "type": "fill",
            "source": "composite",
            "id": "landuse",
            "paint": {
                "fill-color": "rgb(31, 31, 31)",
                "fill-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    8,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "residential",
                        0.8,
                        0.2
                    ],
                    10,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "residential",
                        0,
                        1
                    ]
                ],
                "fill-antialias": false
            },
            "source-layer": "landuse"
        },
        {
            "layout": {
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, land"
            },
            "maxzoom": 16,
            "filter": [
                "all",
                [
                    "step",
                    [
                        "zoom"
                    ],
                    [
                        "==",
                        [
                            "get",
                            "class"
                        ],
                        "shadow"
                    ],
                    11,
                    true
                ],
                [
                    "match",
                    [
                        "get",
                        "level"
                    ],
                    89,
                    true,
                    78,
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        5,
                        true
                    ],
                    67,
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        9,
                        true
                    ],
                    56,
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        6,
                        true
                    ],
                    94,
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        11,
                        true
                    ],
                    90,
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        12,
                        true
                    ],
                    false
                ]
            ],
            "type": "fill",
            "source": "composite",
            "id": "hillshade",
            "paint": {
                "fill-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    14,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "shadow",
                        "rgba(77, 77, 77, 0.06)",
                        "rgba(56, 56, 56, 0.04)"
                    ],
                    16,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "shadow",
                        "rgba(77, 77, 77, 0)",
                        "rgba(56, 56, 56, 0)"
                    ]
                ],
                "fill-antialias": false
            },
            "source-layer": "hillshade"
        },
        {
            "id": "waterway-shadow",
            "type": "line",
            "source": "composite",
            "source-layer": "waterway",
            "minzoom": 10,
            "layout": {
                "line-cap": [
                    "step",
                    [
                        "zoom"
                    ],
                    "butt",
                    11,
                    "round"
                ],
                "line-join": [
                    "step",
                    [
                        "zoom"
                    ],
                    "miter",
                    11,
                    "round"
                ],
                "visibility": "none"
            },
            "paint": {
                "line-color": "rgb(0, 0, 0)",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.3
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "canal",
                            "river"
                        ],
                        0.1,
                        0
                    ],
                    20,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "canal",
                            "river"
                        ],
                        8,
                        3
                    ]
                ],
                "line-translate": [
                    "interpolate",
                    [
                        "exponential",
                        1.2
                    ],
                    [
                        "zoom"
                    ],
                    7,
                    [
                        "literal",
                        [
                            0,
                            0
                        ]
                    ],
                    16,
                    [
                        "literal",
                        [
                            -1,
                            -1
                        ]
                    ]
                ],
                "line-translate-anchor": "viewport",
                "line-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    8,
                    0,
                    8.5,
                    1
                ]
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, water"
            }
        },
        {
            "id": "water-shadow",
            "type": "fill",
            "source": "composite",
            "source-layer": "water",
            "minzoom": 10,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "fill-color": "rgb(0, 0, 0)",
                "fill-translate": [
                    "interpolate",
                    [
                        "exponential",
                        1.2
                    ],
                    [
                        "zoom"
                    ],
                    7,
                    [
                        "literal",
                        [
                            0,
                            0
                        ]
                    ],
                    16,
                    [
                        "literal",
                        [
                            -1,
                            -1
                        ]
                    ]
                ],
                "fill-translate-anchor": "viewport"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, water"
            }
        },
        {
            "id": "waterway",
            "type": "line",
            "source": "composite",
            "source-layer": "waterway",
            "minzoom": 8,
            "layout": {
                "line-cap": [
                    "step",
                    [
                        "zoom"
                    ],
                    "butt",
                    11,
                    "round"
                ],
                "line-join": [
                    "step",
                    [
                        "zoom"
                    ],
                    "miter",
                    11,
                    "round"
                ],
                "visibility": "none"
            },
            "paint": {
                "line-color": "rgb(20, 20, 20)",
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.3
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "canal",
                            "river"
                        ],
                        0.1,
                        0
                    ],
                    20,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "canal",
                            "river"
                        ],
                        8,
                        3
                    ]
                ],
                "line-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    8,
                    0,
                    8.5,
                    1
                ]
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, water"
            }
        },
        {
            "id": "water",
            "type": "fill",
            "source": "composite",
            "source-layer": "water",
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "fill-color": "hsl(0, 85%, 65%)"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, water"
            }
        },
        {
            "minzoom": 13,
            "layout": {
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, built"
            },
            "filter": [
                "all",
                [
                    "==",
                    [
                        "get",
                        "class"
                    ],
                    "land"
                ],
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "Polygon"
                ]
            ],
            "type": "fill",
            "source": "composite",
            "id": "land-structure-polygon",
            "paint": {
                "fill-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    "#000",
                    11,
                    "rgb(36, 36, 36)"
                ]
            },
            "source-layer": "structure"
        },
        {
            "minzoom": 13,
            "layout": {
                "line-cap": "square",
                "visibility": "none"
            },
            "metadata": {
                "mapbox:featureComponent": "land-and-water",
                "mapbox:group": "Land & water, built"
            },
            "filter": [
                "all",
                [
                    "==",
                    [
                        "get",
                        "class"
                    ],
                    "land"
                ],
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ]
            ],
            "type": "line",
            "source": "composite",
            "id": "land-structure-line",
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.99
                    ],
                    [
                        "zoom"
                    ],
                    14,
                    0.75,
                    20,
                    40
                ],
                "line-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    9,
                    "#000",
                    11,
                    "rgb(36, 36, 36)"
                ]
            },
            "source-layer": "structure"
        },
        {
            "id": "background (2)",
            "type": "background",
            "paint": {
                "background-color": "hsl(223, 41%, 64%)"
            }
        },
        {
            "id": "background",
            "type": "background",
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "background-color": "hsl(160, 52%, 4%)"
            },
            "metadata": {
                "mapbox:featureComponent": "satellite",
                "mapbox:group": "Satellite imagery, land"
            }
        },
        {
            "id": "satellite",
            "type": "raster",
            "source": "mapbox://mapbox.satellite",
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "raster-opacity": 0.35,
                "raster-contrast": -0.25,
                "raster-saturation": -0.42,
                "raster-color-mix": [
                    1,
                    1,
                    1,
                    0
                ],
                "raster-brightness-min": 0.13,
                "raster-hue-rotate": 456
            },
            "metadata": {
                "mapbox:featureComponent": "satellite",
                "mapbox:group": "Satellite imagery, land"
            }
        },
        {
            "type": "background",
            "paint": {
                "background-color": "hsla(0, 0%, 0%, 0)"
            },
            "layout": {},
            "id": "background (1)"
        },
        {
            "layout": {},
            "type": "line",
            "source": "composite",
            "id": "road",
            "paint": {
                "line-color": "hsl(194, 76%, 58%)",
                "line-opacity": 0.52
            },
            "source-layer": "road"
        },
        {
            "minzoom": 9,
            "layout": {
                "line-cap": [
                    "step",
                    [
                        "zoom"
                    ],
                    "butt",
                    14,
                    "round"
                ],
                "line-join": [
                    "step",
                    [
                        "zoom"
                    ],
                    "miter",
                    14,
                    "round"
                ]
            },
            "filter": [
                "all",
                [
                    "match",
                    [
                        "get",
                        "class"
                    ],
                    [
                        "secondary",
                        "tertiary"
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "structure"
                    ],
                    [
                        "none",
                        "ford"
                    ],
                    true,
                    false
                ],
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ]
            ],
            "type": "line",
            "source": "composite",
            "id": "road-secondary-tertiary copy",
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.5
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    0,
                    18,
                    26,
                    22,
                    260
                ],
                "line-color": "hsl(194, 76%, 58%)"
            },
            "source-layer": "road"
        },
        {
            "minzoom": 6,
            "layout": {
                "line-cap": [
                    "step",
                    [
                        "zoom"
                    ],
                    "butt",
                    14,
                    "round"
                ],
                "line-join": [
                    "step",
                    [
                        "zoom"
                    ],
                    "miter",
                    14,
                    "round"
                ]
            },
            "filter": [
                "all",
                [
                    "==",
                    [
                        "get",
                        "class"
                    ],
                    "primary"
                ],
                [
                    "match",
                    [
                        "get",
                        "structure"
                    ],
                    [
                        "none",
                        "ford"
                    ],
                    true,
                    false
                ],
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "LineString"
                ]
            ],
            "type": "line",
            "source": "composite",
            "id": "road-primary copy",
            "paint": {
                "line-width": [
                    "interpolate",
                    [
                        "exponential",
                        1.5
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    0.8,
                    18,
                    28,
                    22,
                    280
                ],
                "line-color": "hsl(194, 76%, 58%)"
            },
            "source-layer": "road"
        },
        {
            "layout": {
                "visibility": "none"
            },
            "filter": [
                "match",
                [
                    "geometry-type"
                ],
                [
                    "Polygon"
                ],
                true,
                false
            ],
            "type": "fill-extrusion",
            "source": "composite",
            "id": "building",
            "paint": {
                "fill-extrusion-height": 40,
                "fill-extrusion-color": "hsl(168, 0%, 52%)",
                "fill-extrusion-opacity": 0.25
            },
            "source-layer": "building"
        },
        {
            "layout": {
                "text-field": [
                    "to-string",
                    [
                        "get",
                        "name"
                    ]
                ],
                "text-font": [
                    "Open Sans ExtraBold",
                    "Arial Unicode MS Regular"
                ],
                "text-size": 10
            },
            "filter": [
                "all",
                [
                    "match",
                    [
                        "geometry-type"
                    ],
                    [
                        "Point"
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "class"
                    ],
                    [
                        "settlement",
                        "settlement_subdivision"
                    ],
                    true,
                    false
                ],
                [
                    "match",
                    [
                        "get",
                        "worldview"
                    ],
                    [
                        "all",
                        "US"
                    ],
                    true,
                    false
                ]
            ],
            "type": "symbol",
            "source": "composite",
            "id": "place-label",
            "paint": {
                "text-color": "hsl(194, 71%, 79%)"
            },
            "source-layer": "place_label"
        },
        {
            "minzoom": 5,
            "layout": {},
            "filter": [
                "all",
                [
                    ">=",
                    [
                        "to-number",
                        [
                            "get",
                            "sizerank"
                        ]
                    ],
                    0
                ],
                [
                    "match",
                    [
                        "get",
                        "class"
                    ],
                    [
                        "agriculture",
                        "wood",
                        "grass",
                        "scrub",
                        "glacier",
                        "pitch",
                        "sand"
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        11,
                        true
                    ],
                    "residential",
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        true,
                        10,
                        false
                    ],
                    [
                        "park",
                        "airport"
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        false,
                        8,
                        [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "sizerank"
                                ],
                                1
                            ],
                            true,
                            false
                        ],
                        10,
                        true
                    ],
                    false
                ],
                [
                    "<=",
                    [
                        "-",
                        [
                            "to-number",
                            [
                                "get",
                                "sizerank"
                            ]
                        ],
                        [
                            "interpolate",
                            [
                                "exponential",
                                1.5
                            ],
                            [
                                "zoom"
                            ],
                            12,
                            0,
                            18,
                            14
                        ]
                    ],
                    14
                ]
            ],
            "type": "fill",
            "source": "composite",
            "id": "landuse copy",
            "paint": {
                "fill-color": "hsl(194, 76%, 58%)",
                "fill-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    8,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "residential",
                        0.17,
                        0.15
                    ],
                    10,
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        "residential",
                        0.15,
                        0.42
                    ]
                ],
                "fill-outline-color": "hsla(0, 0%, 0%, 0)"
            },
            "source-layer": "landuse"
        },
        {
            "id": "water-shadow copy",
            "type": "fill",
            "source": "composite",
            "source-layer": "water",
            "minzoom": 10,
            "layout": {},
            "paint": {
                "fill-color": "rgb(0, 0, 0)",
                "fill-translate": [
                    "interpolate",
                    [
                        "exponential",
                        1.2
                    ],
                    [
                        "zoom"
                    ],
                    7,
                    [
                        "literal",
                        [
                            0,
                            0
                        ]
                    ],
                    16,
                    [
                        "literal",
                        [
                            -1,
                            -1
                        ]
                    ]
                ],
                "fill-translate-anchor": "viewport",
                "fill-opacity": 0.23
            }
        },
        {
            "id": "water copy",
            "type": "fill",
            "source": "composite",
            "source-layer": "water",
            "layout": {},
            "paint": {
                "fill-color": "hsl(194, 76%, 64%)"
            }
        }
    ],
    "created": "2024-11-13T22:22:40.070Z",
    "modified": "2024-11-15T13:40:32.059Z",
    "id": "cm3gg5sjq001f01r2cl0cgfdy",
    "owner": "leceles",
    "visibility": "private",
    "protected": false,
    "draft": false
}



// style.sources = {"composite": mapboxundercover}
style.sprite =  window.location.origin+"/images/sprites"




export default style;







var style2 = {
    "version": 8,
    "name": "voltadolago-copy",
    "metadata": {
        "mapbox:autocomposite": true,
        "mapbox:type": "template"
    },
    "center": [
        -47.882074522463995,
        -15.806249277207186
    ],
    "zoom": 15.404946541587915,
    "bearing": 20.61917208114255,
    "pitch": 60,
    "light": {
        "color": "white",
        "intensity": 0.87,
        "anchor": "viewport"
    },
    "sources": {
        "composite": mapboxundercover
    },
    "sprite": window.location.origin+"/images/sprites",
    "glyphs": "mapbox://fonts/leceles/{fontstack}/{range}.pbf",
    "layers": [
        {
            "id": "background (1)",
            "type": "background",
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "background-color": "hsla(0, 73%, 63%, 0)"
            }
        },
        {
            "id": "road",
            "type": "line",
            "source": "composite",
            "source-layer": "road",
            "layout": {
                "visibility": "visible",
                "line-join": "round"
            },
            "paint": {
                "line-color": "hsla(0, 0, 0, 0.05)",
                "line-opacity": {
                    "base": 1,
                    "stops": [
                        [
                            11,
                            0
                        ],
                        [
                            13,
                            1
                        ]
                    ]
                },
                "line-width": {
                    "base": 1,
                    "stops": [
                        [
                            12,
                            2
                        ],
                        [
                            16,
                            3
                        ],
                         [
                            20,
                            10
                        ]
                    ]
                }
            }
        },
        {
            "id": "building",
            "type": "fill",
            "source": "composite",
            "source-layer": "building",
            "filter": [
                "==",
                "$type",
                "Polygon"
            ],
            "layout": {},
            "paint": {
                "fill-color": "hsl(0, 76%, 58%)",
                "fill-outline-color": "hsla(0, 0%, 0%, 0)",
                "fill-opacity": 0.17,
                "fill-antialias": false
            }
        },
        {
            "id": "place-label",
            "type": "symbol",
            "source": "composite",
            "source-layer": "place_label",
            "layout": {
                "visibility": "visible",
                "text-field": {
                    "base": 1,
                    "type": "categorical",
                    "property": "name",
                    "stops": [
                        [
                            "",
                            ""
                        ]
                    ]
                }
            },
            "paint": {}
        }
    ],
    "created": "2018-02-20T11:50:58.453Z",
    "id": "cjdvl9kiu682f2rq9f91i6z7l",
    "modified": "2018-02-26T12:58:37.164Z",
    "owner": "leceles",
    "visibility": "private",
    "draft": false
}






